<template>
	<div>
		<top></top>
		<div class="con">
			<register @logType="logType" v-if="type == 2"></register>
			<login  @logType="logType" v-if="type == 1"></login>
            <forgetP  @logType="logType" v-if="type == 3"></forgetP>
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import top from '../../components/top.vue'
	import register from '../../components/register.vue'
	import bottom from '../../components/bottom.vue'
    import login from '../../components/login.vue'
    import forgetP from '../../components/forgetPaaword.vue'
	import {category,lists} from '@/api/index.js'
	export default {
		data() {
			return {
				type:'1', //1登录  2注册 3更改密码
			}
		},
		beforeCreate () {
			document.querySelector('body').setAttribute('style', 'background:#f5f5f5')
		},
		created() {
			if(this.$route.query.type){
				this.type = this.$route.query.type
			}
		},
		watch:{
			$route:{
				handler(val,oldval){
					this.type = val.query.type
					var userJsonStr = localStorage.getItem('userInfo');
					var userEntity = JSON.parse(userJsonStr);
					console.log(userEntity,'22222'); // => tom
				  },
				  // 深度观察监听
				  deep: true
			}
		},
		methods:{
			logType(e){
				this.type = e.type
				console.log(e,'eee')
			}
		},
		components:{
			top,
			register,
			bottom,
            login,
            forgetP
		}
	}
</script>

<style lang="less" scoped>
.con{
	height: 687px;
	width: 100%;
	background-color: #FFECEC;
	padding: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
}


</style>



// WEBPACK FOOTER //
// src/views/index/login.vue